import { ScoreGoal, ScoreGoalDto, ScoreGoalInput } from '../../../types'
import { AppraisalContextType } from '../AppraisalTypes'

export const employeeEvaluationScoreOf = (scoreGoals: ScoreGoal[]): number => {
  let sum = 0
  scoreGoals.forEach((goal) => (sum += goal.employeeEvaluation ? goal.employeeEvaluation : 0))
  return sum / scoreGoals.length
}

export const generateInitialState = (scoreGoals: ScoreGoalDto[], meetingContext: AppraisalContextType): ScoreGoalDto[] => {
  if (meetingContext === AppraisalContextType.Meeting) {
    const initialState = [...scoreGoals].map((goal) => {
      const newGoal = { ...goal }
      if (
        !newGoal.resultEvaluation &&
        newGoal.employeeEvaluation &&
        newGoal.reviewerEvaluation &&
        newGoal.reviewerEvaluation === newGoal.employeeEvaluation
      ) {
        newGoal.resultEvaluation = newGoal.reviewerEvaluation
        return newGoal
      }
      return newGoal
    })
    return initialState
  }
  return scoreGoals
}

// This method assumes that the lists of scoreGoals include all types of score goals (ScoreGoalType)
export const areScoreGoalsEquals = (scoreGoalsA: ScoreGoalDto[], scoreGoalsB: ScoreGoalDto[], type: AppraisalContextType): boolean => {
  for (const sgA of scoreGoalsA) {
    const sgB = scoreGoalsB.find((sg) => sg.viewId === sgA.viewId)!
    const sgAValue =
      type === AppraisalContextType.Employee
        ? sgA.employeeEvaluation
        : type === AppraisalContextType.Manager
        ? sgA.reviewerEvaluation
        : sgA.resultEvaluation
    const sgBValue =
      type === AppraisalContextType.Employee
        ? sgB.employeeEvaluation
        : type === AppraisalContextType.Manager
        ? sgB.reviewerEvaluation
        : sgB.resultEvaluation
    if (sgAValue !== sgBValue) return false
  }
  return true
}

// This method assumes that the list of scoreGoals includes all types of score goals (ScoreGoalType)
export const allScoreGoalsExist = (scoreGoals: ScoreGoalDto[], type: AppraisalContextType): boolean => {
  for (const sg of scoreGoals) {
    const value =
      type === AppraisalContextType.Employee
        ? sg.employeeEvaluation
        : type === AppraisalContextType.Manager
        ? sg.reviewerEvaluation
        : sg.resultEvaluation
    if (!value) return false
  }

  return true
}

export const mapGoalsToInput = (goals: ScoreGoalDto[]): ScoreGoalInput[] => {
  return [...goals].map((goal) => ({ ...goal, lastResultEvaluation: undefined }))
}

export const mapGoalsFromInitialState = (
  goals: ScoreGoalDto[],
  meetingContext: AppraisalContextType,
  evaluationVisible: boolean,
): ScoreGoalInput[] => {
  if (meetingContext === AppraisalContextType.Meeting) {
    return goals.map(
      (goal): ScoreGoalInput =>
        ({
          ...goal,
          lastResultEvaluation: undefined,
          resultEvaluation: goal.resultEvaluation
            ? goal.resultEvaluation
            : evaluationVisible && goal.employeeEvaluation && goal.reviewerEvaluation && goal.employeeEvaluation === goal.reviewerEvaluation
            ? goal.reviewerEvaluation
            : undefined,
        } as ScoreGoalInput),
    )
  }
  return mapGoalsToInput(goals)
}
